// MortonCode is 64 bit Cardinal. so we can directly type alias with
// a number
import Long from 'long';

export type MortonCode = Long;
export type PPCVoxelId = Long;
export type PPCChunkId = Long;
export type PPCPointIndex = Long;

// PPC Level is Cardinal8 means 8 bit binary so we need to
// see if we can reduce the size of the PPCLevel
export type PPCLevel = number;

export enum CompressionType {
  NoCompression,
  VarByteDeltaCompression,
  Simple8Compression,
  Simple8DeltaCompression,
}

export enum PPCPointCloudType {
  PPC3D,
  PPC2D,
}
export enum PPCOctant {
  DownSouthWest,
  DownSouthEast,
  DownNorthWest,
  DownNorthEast,
  UpSouthWest,
  UpSouthEast,
  UpNorthWest,
  UpNorthEast,
}

let octantsArray: Array<PPCOctant> | null = null;
export function getOctantsArray(): Array<PPCOctant> {
  if (octantsArray === null) {
    octantsArray = [PPCOctant.DownSouthWest, PPCOctant.DownSouthEast, PPCOctant.DownNorthWest, PPCOctant.DownNorthEast, PPCOctant.UpSouthWest, PPCOctant.UpSouthEast, PPCOctant.UpNorthWest, PPCOctant.UpNorthEast];
  }
  return octantsArray;
}
export enum PPCVoxelAttribute {
  HasTreeClipping, // clipping of a voxel and its complete subtree
  HasVoxelClipping, // clipping of a voxel alone
  HasChildMask, // child mask
  HasChildOffset, // child offset
  HasVoxelId, // voxel identifiers
  HasNeighbours, // voxel direct neighbour occupancy flags. tNeighbour
  HasXY, // voxel xy position
  HasZ, // elevation
  HasRGB, // Red-Green-Blue color
  HasIntensity, // Intensity
  HasClassification, // Classification
  HasDifference, // Calculated in Pythagoras from difference calculations
  HasContourInfo, // temporary info for contours
}

export enum PPCEditType {
  NoEdit, // edit of something else - no point clouds
  EditClip, // clipping operation
  EditClassify, // classification
  EditCalcDifference, // difference calculation
  EditCalcContours, // contour calculation
}

export type UndoState = number;

export type PPCClassification = number;
